import { ReactComponent as GoatHeadSvg } from './svgs/goat_head.svg';

const goat_head_svg_path = 'goat_head_illustration.svg';

export default function GoatHeadIcon () {
    return (
        <GoatHeadSvg />
    )
} 